import { lazy, Suspense } from 'react';
import { ActivityIndicator } from 'react-native';
import { Box } from '../../src/components/primitives';
import { colors } from '../../src/theme/colors';

const MissionControlView = lazy(() =>
  import('../../src/features/mission-control/components/MissionControlView').then((mod) => ({
    default: mod.MissionControlView,
  })),
);

function LoadingFallback() {
  return (
    <Box
      flex={1}
      alignItems="center"
      justifyContent="center"
      backgroundColor={colors.background.primary}
    >
      <ActivityIndicator size="large" color={colors.primary.neon} />
    </Box>
  );
}

export default function MissionControlScreen() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <MissionControlView />
    </Suspense>
  );
}
